import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const Schalungsarbeiten = () => {
  const pageData = {
    title: 'SCHALUNG & BETON',
    subtitle: 'Fundamente & Beton',
    description: 'Präzise Schalungsarbeiten für Fundamente, Wände und Decken. Stabile Basis für Ihr Bauvorhaben.',
    heroImage: 'https://customer-assets.emergentagent.com/job_cazis-bauexperte/artifacts/udix18oe_WhatsApp%20Image%202026-05-01%20at%2010.45.52%20%282%29.jpeg',
    features: [
      { title: 'Fundamentschalungen', description: 'Stabile Schalungen für Fundamente aller Art.' },
      { title: 'Wandschalungen', description: 'Präzise Schalungen für Betonwände.' },
      { title: 'Deckenschalungen', description: 'Tragfähige Deckenschalungen für Betondecken.' },
      { title: 'Sonderschalungen', description: 'Individuelle Lösungen für besondere Anforderungen.' },
      { title: 'Betonarbeiten', description: 'Fachgerechtes Einbringen und Verdichten von Beton.' },
      { title: 'Nachbehandlung', description: 'Professionelle Nachbehandlung des Betons.' }
    ],
    benefits: [
      'Erfahrenes Fachpersonal',
      'Hochwertige Schalungssysteme',
      'Präzise Maßarbeit',
      'Zuverlässige Umsetzung',
      'Einhaltung aller Normen',
      'Effiziente Arbeitsweise'
    ],
    process: [
      { title: 'Planung', description: 'Detaillierte Planung der Schalungskonstruktion.' },
      { title: 'Aufbau', description: 'Montage der Schalung nach Plan.' },
      { title: 'Betonieren', description: 'Fachgerechtes Einbringen des Betons.' },
      { title: 'Ausschalen', description: 'Entfernung der Schalung nach Aushärtung.' }
    ],
    gallery: [
      'https://customer-assets.emergentagent.com/job_cazis-bauexperte/artifacts/0964farb_WhatsApp%20Image%202026-05-01%20at%2010.45.51%20%283%29.jpeg',
      'https://customer-assets.emergentagent.com/job_cazis-bauexperte/artifacts/96cre3r2_WhatsApp%20Image%202026-05-01%20at%2010.45.51%20%284%29.jpeg'
    ],
    metaKeywords: 'Schalungsarbeiten Graubünden, Betonarbeiten Cazis, Fundamentschalungen'
  };

  return <ServiceTemplate {...pageData} />;
};

export default Schalungsarbeiten;